<template>
  <div>
        <span @click="search()">
            <Button type="primary" @click="operationDutyManagementModal = true"
                    v-hasPermission="['operationKpiConfigurationManagement:operationDutyManagement:add_duty']">{{$t('MCM.dutyManagement.addDuty')}}</Button>
        </span>
    <Modal v-model="operationDutyManagementModal" :title="$t('MCM.dutyManagement.addDuty')" :loading="loading"
           @on-ok="operationDutyManagementSubmit('operationDutyManagementForm')"
           @on-cancel="operationDutyManagementReset('operationDutyManagementForm')" :mask-closable="false"
           :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')">
      <Form ref="operationDutyManagementForm" :model="operationDutyManagementForm" :label-width="100"
            :rules="ruleValidate">
        <!-- 姓名 -->
        <FormItem :label="$t('MCM.dutyManagement.name')" prop="name">
          <Select v-model="operationDutyManagementForm.name" style="width:300px;" placeholder="Please select">
            <Option :value="item.id" v-for="item in nameList" v-bind:key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <!-- 值班类型 -->
        <FormItem :label="$t('MCM.dutyManagement.dutyType')" prop="ondutyType">
          <Select v-model="operationDutyManagementForm.ondutyType" style="width:300px;" placeholder="Please select">
            <Option :value="item.id" v-for="item in ondutyTypeList" v-bind:key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <!-- 值班时间 -->
        <FormItem :label="$t('MCM.dutyManagement.dutyTime')" prop="ondutyTime">
          <DatePicker type="date" multiple :placeholder="$t('MCM.dutyManagement.pleaseSelectDutyTime')"
                      v-model="operationDutyManagementForm.ondutyTime"
                      style="width:300px;"></DatePicker>
        </FormItem>

        <!-- 排班优先级 -->
        <FormItem :label="$t('MCM.dutyManagement.priority')" prop="schedulingPriority">
          <Select v-model="operationDutyManagementForm.schedulingPriority" style="width:300px;"
                  placeholder="Please select">
            <Option :value="item.id" v-for="item in schedulingPriorityList" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>

        <!-- 备注 -->
        <FormItem :label="$t('MCM.dutyManagement.comment')" prop="remark">
          <Input v-model="operationDutyManagementForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
                 placeholder="Enter something..." style="width:300px;"></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
  import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'
  import TableOperationDutyManagement from '../operation_duty_management/TableOperationDutyManagement'

  var tableOperationDutyManagement = TableOperationDutyManagement;
  export default {
    data() {
      return {
        loading: true,
        operationDutyManagementModal: false,
        nameList: [],
        ondutyTypeList: [{
          id: 0,
          name: this.$t('MCM.dutyManagement.dayShift')
        }, {
          id: 1,
          name: this.$t('MCM.dutyManagement.nightShift')
        }],
        operationDutyManagementForm: {
          name: '',
          ondutyType: '',
          ondutyTime: '',
          schedulingPriority: '',
          remark: ''
        },
        schedulingPriorityList: [],
        ruleValidate: {
          name: [
            {required: true, message: this.$t('MCM.dutyManagement.pleaseSelectName'), trigger: 'change', type: 'number'}
          ],
          ondutyType: [
            {
              required: true,
              message: this.$t('MCM.dutyManagement.pleaseSelectDutyType'),
              trigger: 'change',
              type: 'number'
            }
          ],
          schedulingPriority: [
            {
              required: true,
              message: this.$t('MCM.dutyManagement.pleaseSelectPriority'),
              trigger: 'change',
              type: 'number'
            }
          ],
          ondutyTime: [
            {
              type: 'array',
              required: true,
              message: this.$t('MCM.dutyManagement.pleaseSelectDutyTime'),
              fields: {
                0: {
                  required: true,
                  type: 'date',
                  message: this.$t('MCM.dutyManagement.pleaseSelectDutyTime'),
                  trigger: 'change'
                }
              }
            }
          ],
          remark: [
            {
              required: false,
              message: this.$t('MCM.extraContributionManagement.pleaseEnterDescription'),
              trigger: 'blur'
            },
            {
              type: 'string',
              max: 10000,
              message: this.$t('MCM.extraContributionManagement.EnterMaximumOfCharacters'),
              trigger: 'blur'
            }
          ]
        }
      }
    },
    mounted: function () {
      this.selectSchedulingPriorityList();
    },
    methods: {
      search: function () {
        this.$api.user.getOperationUsers({})
          .then(res => {
            this.nameList = res.data;
          })
      },
      // 查询排班优先级
      selectSchedulingPriorityList: function () {
        this.$api.kpiShift.selectSchedulingPriorityList("userName", getCookie(global.cookieName))
          .then(res => {
            this.schedulingPriorityList = res.data;
          });
      },
      operationDutyManagementSubmit: function (name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            // 添加
            this.$api.kpiShift.insertOrUpdate({
              "userId": this.operationDutyManagementForm.name,
              "shiftType": this.operationDutyManagementForm.ondutyType,
              "shiftDateList": this.operationDutyManagementForm.ondutyTime,
              "schedulingPriority": this.operationDutyManagementForm.schedulingPriority,
              "remark": this.operationDutyManagementForm.remark
            })
              .then(res => {
                setTimeout(() => {
                  tableOperationDutyManagement.methods.showAll();
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success('添加成功');
                  this.operationDutyManagementModal = false;
                }, 1000);
              })
          } else {
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            this.$Message.error('添加失败');
          }
        });
      },
      operationDutyManagementReset: function (name) {
        this.$refs[name].resetFields();
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_duty_management/AddOperationDutyManagement.vue